var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.756 9.68C9.344 4.015 14.856 0 21.25 0c7.2 0 13.125 5.385 13.7 12.213 2.875.546 5.05 3 5.05 5.938C40 21.177 37.5 24 32.857 24h-7.143s-1.428 0-1.428-1.412 1.428-1.412 1.428-1.412h8.036c2.069 0 3.75-1.023 3.75-3.025 0-2.001-1.681-3.63-3.75-3.63-.694 0-1.25-.542-1.25-1.21 0-6.005-5.05-10.89-11.25-10.89-5.556 0-10.294 3.656-11.275 8.694-.106.571-.625.986-1.225.986H7.5c-2.756 0-5 2.171-5 4.84s1.887 4.236 4.643 4.236h7.143s1.428 0 1.428 1.411C15.714 24 14.286 24 14.286 24H7.143C2.5 24 0 21.177 0 16.941c0-4.235 3.362-7.26 7.5-7.26h.256Zm13.64 5.633v17.25c0 .718-.696 1.437-1.4 1.437-.696 0-1.4-.719-1.4-1.438v-17.25l-3.206 2.98a1.498 1.498 0 0 1-1.98 0 1.202 1.202 0 0 1 0-1.807l5.6-5.111c.272-.25.63-.374.986-.374.358 0 .722.125.995.374l5.6 5.11a1.202 1.202 0 0 1 0 1.808 1.498 1.498 0 0 1-1.982 0l-3.213-2.98Z",
    fill: "#131516"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.8b6bc71a2f6a0f27d01cf1f4fe6273b0.svg";
export { ForwardRef as ReactComponent };